import __ from '../util/i18n';

export default function() {
  $(document).ready(function() {
    (function() {
      var ellipsesText = "...";

      $(".truncate").each(function() {
        let showChar = $(this).data('truncate-max-chars');
        var content = $(this).html();
        if (content.length > showChar) {
          var truncatedText = content.substr(0, showChar);
          var html =
            '<div class="truncate-text" style="display:block">' +
            truncatedText +
            '<span class="moreellipses">' +
            ellipsesText +
            '&nbsp;&nbsp;<a href="" class="moreless more">' + __('Read more') + '</a></span></span></div><div class="truncate-text" style="display:none">' +
            content +
            '<a href="" class="moreless less">' + __('Less') + '</a></span></div>';

          $(this).html(html);
        }
      });

      $(".moreless").click(function() {
        var thisEl = $(this);
        let truncatedText = thisEl.closest(".truncate-text");
        let originText = ".truncate-text";

        if (thisEl.hasClass("less")) {
          truncatedText.prev(originText).toggle();
          truncatedText.toggle();
        } else {
          truncatedText.toggle();
          truncatedText.next(originText).toggle();
        }
        return false;
      });
    })();
  });
}



// WEBPACK FOOTER //
// ./scripts/util/truncate.js